import horizon from './horizon.jpg';
import RDR2 from './RDR2.jpg';
import Fifa from './Fifa.jpg';
import AOE4 from './AOE4.jpg';
import GOW from './God of war.jpg';
import Batman from './arkham knight.jpg';
import EldenRing from './Elden Ring.jpg';
import valorant from './valorant.jpg';
import civilization from './civilization.jpg';
import AOE2 from './AOE2.jpg';
import NBA from './NBA.jpg';
import sekiro from './sekiro.jpg';
import witcher from './witcher.jpg';
import mario from './mario.jpg';
import emptyCart from './empty-cart.jpg';
import emptyWishlist from './empty-wishlist.jpg';
import error404 from './404.png';
import codmw from './codmw.jpg';
import gtav from './gtav.jpg';
import rl from './rl.jpg';
import minecraft from './minecraft.png';
import portal from './portal.jpg';

const carouselImgs = [GOW, RDR2, Fifa];

export {
	horizon,
	RDR2,
	Fifa,
	AOE4,
	GOW,
	carouselImgs,
	Batman,
	EldenRing,
	valorant,
	civilization,
	AOE2,
	NBA,
	sekiro,
	witcher,
	mario,
	emptyCart,
	emptyWishlist,
	error404,
	codmw,
	gtav,
	rl,
	minecraft,
	portal,
};
